<div mat-dialog-title class="text-center mb-0 fw-bold mt-3">
    <mat-icon class="w-25" style="height: 50px;" [svgIcon]="googleSheetIcon"></mat-icon>
</div>

<mat-divider></mat-divider>

<mat-dialog-content>
    <div class="container-fluid" [formGroup]="googleSheetIntegrationForm">
        <div class="row">
            <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>The name of the google sheet to be created</mat-label>
                <mat-error>You need to enter a name</mat-error>
                <input matInput placeholder="Ex: Add user to crm" formControlName="sheetName" required>
                <mat-hint>Enter the the name of the google sheet to be created</mat-hint>
            </mat-form-field>
        </div>

        <div class="row">
            <app-form-entries [formEntryForm]="googleSheetIntegrationForm"
                [formEntries]="data.googleSheetIntegration?.formEntries || []"></app-form-entries>
        </div>
    </div>
</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions class="d-flex mt-1 justify-content-around">
    <button mat-dialog-close mat-raised-button class="w-25" [disabled]=" isLoading " color="warn">Close</button>
    <button (click)="onSubmit()" mat-raised-button class="w-25"
        [disabled]="!googleSheetIntegrationForm.valid || isLoading" color="primary">
        <span *ngIf="!isLoading">
            save
        </span>
        <mat-spinner *ngIf="isLoading" [diameter]="30" [strokeWidth]="3" class="mx-auto mat-spinner"></mat-spinner>
    </button>
</mat-dialog-actions>